import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconArrowRight, IconSavings } from '@redteclab/icons'

import { Button, Notification } from 'base-ui'

import {
  EXPERIMENTS_TRACK_EVENT_PDP_CART_DRAWER_GO_SPECIAL_OFFERS,
  experimentsTrackEvent,
} from '../../../experiments/eventTracking'
import { useGlobalConfigContext } from '../../../global-config'

export const CartIntermediateSpecialOffers: FC = () => {
  const intl = useIntl()
  const globalConfig = useGlobalConfigContext()

  return (
    <Notification className="mb-3" icon={<IconSavings />} severity="info">
      <div className="flex items-center justify-between">
        <FormattedMessage id="cartIntermediate.drawer.specialOffers.title" />
        <Button className="tablet:hidden" size="medium">
          <IconArrowRight className="size-5" />
        </Button>
        <Button
          className="hidden tablet:block"
          onClick={() => {
            experimentsTrackEvent(
              globalConfig,
              EXPERIMENTS_TRACK_EVENT_PDP_CART_DRAWER_GO_SPECIAL_OFFERS,
            )
          }}
          size="small"
        >
          {intl.formatMessage({
            id: 'cartIntermediate.drawer.specialOffers.button',
          })}
        </Button>
      </div>
    </Notification>
  )
}
